export interface LeadFeeChange {
  readonly state: string
  readonly newValue: string
}

/**
 * Folds every pending per-state lead-fee edit into ONE object.
 *
 * `writeEnvKey` replaces the whole `stateToLeadFee` child, so building a fresh
 * object per change from the same stale `current` and writing each one kept
 * only the last state edited (the others silently reverted).
 */
export const applyLeadFeeChanges = (
  current: Readonly<Record<string, number>> | null,
  changes: readonly LeadFeeChange[],
): Record<string, number> | null => {
  if (changes.length === 0) return null

  const next: Record<string, number> = current ? { ...current } : {}
  for (const { state, newValue } of changes) {
    const parsed = parseFloat(newValue)
    next[state] = isNaN(parsed) ? 0 : parsed
  }
  return next
}
